<template>
    <div>
        <SendError1Window :letter="failedLetter"/>
        <SendError2Window :addressee-list="addresseeList" :letter="failedLetter"/>
        <SendError2Window :addressee-list="addresseeList" :letter="failedLetter" @resendLetter="sendLetterToAddressee"/>
        <SendError3Window :social-list="socialList" :letter="failedLetter" @resendLetter="sendLetterToEmail"/>
        <SendError4Window :addressee-list="addresseeList" :letter="failedLetter" :social-list="socialList"
                          @resendLetterToNewEmail="sendLetterToEmail" @resendLetterToAddressee="sendLetterToAddressee"/>

        <div class="layout">

            <div class="cabinet-page_bg"></div>

            <HeaderAuth/>
            <div class="cabinet-content-block-wrapper">
                <div class="cabinet-content-block">

                    <AdminNavigation/>
                    <div class="cabinet-content">
                        <div class="heading-wrapper">
                            <div class="title" v-html="$ml.with('VueJS').get('notifications')"></div>
                        </div>
                        <div v-if="notifications.length === 0" class="cabinet-content-inner">
                            <div class="notice-list">
                                <div class="msg-page-empty">Нет уведомлений</div>
                            </div>
                        </div>
                        <div v-else class="cabinet-content-inner">

                            <div class="notice-list">

                                <div v-for="dto in notifications">
                                    <router-link
                                        v-if="dto.notification.type === 'contact' || dto.notification.type === 'pay_error'"
                                        :to="'client?id=' + dto.notification.client.id + '&return=notifications'"
                                        class="notice-item"
                                        :class="{'notice-new': !dto.read}"
                                    >
                                        <div class="notice-item__row">
                                            <div class="notice-item__icon"></div>
                                            <div class="notice-item__title">
                                                {{ dto.notification.title }}
                                            </div>
                                            <div class="notice-item__date">{{ dto.notification.dateTimeStr }}</div>
                                        </div>
                                        <div class="notice-item__desc">
                                            <span v-if="dto.notification.type === 'contact'">
                                                Пожалуйста, свяжитесь с Клиентом <strong>{{ getFIO(dto.notification.client) }}</strong> и уточните о возобновлении подписки.
                                            </span>
                                            <span v-else-if="dto.notification.type === 'pay_error'">
                                                Не удалось списать абонентскую плату у пользователя <strong>{{ getFIO(dto.notification.client) }}</strong>. Пожалуйста, свяжитесь с ним.
                                            </span>
                                            <span v-else>
                                                {{ dto.notification.text }}
                                            </span>
                                        </div>
                                        <div class="notice-item__arrow">
                                            <ArrowNoticeIcon/>
                                        </div>
                                    </router-link>
                                    <a v-else
                                       href="#"
                                       class="notice-item"
                                       :class="{'notice-new': !dto.read}"
                                       @click="openWindow(dto)"
                                    >
                                        <div class="notice-item__row">
                                            <div class="notice-item__icon"></div>
                                            <div class="notice-item__title">
                                                {{ dto.notification.title }}
                                            </div>
                                            <div class="notice-item__date">{{ dto.notification.dateTimeStr }}</div>
                                        </div>
                                        <div class="notice-item__desc" v-html="dto.notification.text">
                                        </div>
                                        <div class="notice-item__arrow">
                                            <ArrowNoticeIcon/>
                                        </div>
                                    </a>
                                </div>


                            </div>

                            <div v-show="pageCount > 1" class="pagination">
                                <ul>
                                    <li class="nav nav-first" :class="{'disabled' : pageNumber === 1}"
                                        @click="goToPage(1)"><span><ArrowFirstIcon/></span></li>
                                    <li class="nav nav-prev" :class="{'disabled' : pageNumber === 1}"
                                        @click="goToPage(pageNumber - 1)"><span><ArrowPrevIcon/></span></li>
                                    <li v-for="i in pagesToShow" :class="{'active' : i === pageNumber}"
                                        @click="goToPage(i)">
                                        <span v-if="i === pageNumber">{{ (i) }}</span>
                                        <a v-else>{{ i }}</a>
                                    </li>
                                    <li class="nav nav-next" :class="{'disabled' : pageNumber === pageCount}"
                                        @click="goToPage(pageNumber + 1)"><span><ArrowPrevIcon/></span></li>
                                    <li class="nav nav-last" :class="{'disabled' : pageNumber === pageCount}"
                                        @click="goToPage(pageCount)"><span><ArrowFirstIcon/></span></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        <FooterAuth/>
    </div>
</template>


<script>

import FooterAuth from "../../components/FooterAuth";
import HeaderAuth from "../../components/HeaderAuth";
import AdminNavigation from "../../components/AdminNavigation";
import ArrowNoticeIcon from "@/components/icons/ArrowNoticeIcon";
import rest from "../../restUtils";
import ArrowFirstIcon from "@/components/icons/ArrowFirstIcon";
import ArrowPrevIcon from "@/components/icons/ArrowPrevIcon";
import SendError1Window from "@/components/windows/SendError1Window";
import SendError2Window from "@/components/windows/SendError2Window";
import SendError3Window from "@/components/windows/SendError3Window";
import SendError4Window from "@/components/windows/SendError4Window";

export default {
    name: 'Notifications',
    components: {
        SendError2Window,
        SendError4Window,
        SendError3Window,
        SendError1Window,
        ArrowPrevIcon, ArrowFirstIcon, ArrowNoticeIcon, AdminNavigation, HeaderAuth, FooterAuth
    },
    metaInfo: {
        title: 'Уведомления | Your Last Word'
    },

    data() {
        return {
            notifications: [],
            totalSize: 0,
            countOnPage: 10,
            pageNumber: 1,
            pageCount: 1,
            failedLetter: {},
            addresseeList: [],
            socialList: [],
            clientId: '',
        }
    },

    beforeCreate() {
        $('body').attr('class', 'cabinet-page');
    },

    async created() {
        await this.loadNotifications(1);
    },

    computed: {
        pagesToShow() {
            let result = [];
            if (this.pageCount < 5) {
                for (let i = 0; i < this.pageCount; i++) {
                    result[i] = i + 1;
                }
            } else {
                let start = this.pageNumber;
                let finish = start + 5;
                if (finish > this.pageCount) {
                    start = this.pageCount - 4;
                }
                for (let i = 0; i < 5; i++) {
                    result[i] = start + i;
                }
            }
            return result;
        }
    },

    methods: {
        async loadNotifications(pageNumber) {
            let data = await rest.doGet("/admin/notification?page=" + pageNumber);
            this.notifications = data.notifications;
            this.totalSize = data.size;
            this.countOnPage = data.countOnPage;

            this.pageCount = Math.ceil(this.totalSize / this.countOnPage);
        },
        openWindow(dto) {
            this.addresseeList = dto.notification.client.addresseeList;
            this.clientId = dto.notification.client.id;
            this.sendLetter(dto.notification.letter);
        },
        sendLetter(letter) {
            if (letter.sendStatus === 'failed') {
                this.failedLetter = letter;
                $('.window-client-check-error').addClass('window-open');
                $('body').addClass('blocked');
            } else if (letter.sendStatus === 'failed_retry' && letter.agreement && letter.socialList !== '') {
                this.failedLetter = letter;
                this.socialList = letter.socialList.split(",");
                $('.window-client-check-error-4').addClass('window-open');
                $('body').addClass('blocked');
            } else if (letter.sendStatus === 'failed_retry' && letter.agreement) {
                this.failedLetter = letter;
                $('.window-client-check-error-2').addClass('window-open');
                $('body').addClass('blocked');
            } else if (letter.sendStatus === 'failed_retry' && letter.socialList !== '') {
                this.failedLetter = letter;
                this.socialList = letter.socialList.split(",");
                $('.window-client-check-error-3').addClass('window-open');
                $('body').addClass('blocked');
            }

        },
        goToPage(pageNumber) {
            if (pageNumber >= 1 && pageNumber <= this.pageCount) {
                this.pageNumber = pageNumber;
                this.loadNotifications(pageNumber);
            }
        },
        async sendLetterToAddressee(letter, addresseeId) {
            let response = await rest.doPost("/admin/client/" + this.clientId + "/mail/resendAddressee?letterId=" + letter.id + "&addresseeId=" + addresseeId);

            if (response.sendStatus === 'failed_retry') {
                this.failedLetter = response;
                this.sendLetter(response);
            }
        },
        async sendLetterToEmail(letter, newEmails) {
            let emails = newEmails.join(",");
            let response = await rest.doPost("/admin/client/" + this.clientId + "/mail/resendNewMail?letterId=" + letter.id + "&newEmails=" + emails);

            this.sendLetter(response);
        },
        getFIO(client) {
            return client.surname + " " + client.name + ((client.patronymic == null || client.patronymic === '') ? "" : " " + client.patronymic);
        }
    }
}

</script>

